<template>
  <section id="homegallery" class="n2-seccion" v-if="G?.Mostrar && fotos.length">
    <div class="n2-contenedor">
      <div class="n2-cabeza-seccion n2-aparece">
        <h2 class="n2-titulo-seccion" v-html="G.Titulo?.Texto || tituloSeccion(NOTARIA, 'Gallery', $t)"></h2>
        <div v-if="G.Descripcion?.Texto" class="n2-entradilla" :style="alineacionTexto(G.Descripcion.css)" v-html="G.Descripcion.Texto"></div>
      </div>
      <div class="n2-mosaico">
        <button v-for="(f, i) in fotos" :key="f.id" type="button" class="n2-mosaico__foto n2-aparece" @click="indice = i; abierta = true"
          :aria-label="f.Description || f.name">
          <img :src="imagenIDtoSRC(f.id)" :alt="f.Description || ''" loading="lazy" />
          <span v-if="G.MostrarDescripcion && f.Description">{{ f.Description }}</span>
        </button>
      </div>
    </div>
    <GalleryLightbox v-model="abierta" :images="fotos.map(f => ({ src: imagenIDtoSRC(f.id) }))" :initialIndex="indice" />
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { tituloSeccion, alineacionTexto } from '../../composables/useNotaria2'

const store = useStore()
const { NOTARIA, ARCHIVOS_COMUNES } = storeToRefs(store)
const { imagenIDtoSRC, $t } = useUtils()
const abierta = ref(false)
const indice = ref(0)

// Panel: Inicio → Galería y las imágenes marcadas "Mostrar en la sección de inicio"
const G = computed(() => NOTARIA.value?.Theme?.Home?.Gallery)
const fotos = computed(() => {
  const origen = ARCHIVOS_COMUNES.value?.length ? ARCHIVOS_COMUNES.value : (NOTARIA.value?.Archivos ?? [])
  const lista = origen.filter(a => a.id && a.showInGallerySection)
    .sort((a, b) => (Number(a.Orden) || 9999) - (Number(b.Orden) || 9999))
  const total = Number(G.value?.TotalImagenes) || 0
  return total > 0 ? lista.slice(0, total) : lista
})
</script>
